import Link from "next/link";

import { Project } from "interfaces";

import { useFetchDataFile } from "modules/data-files/api";

import {
  TextMiningProject,
  projectIsTextMining,
} from "flows/text-mining/interfaces";

import { getDataFileId } from "flows/text-mining/utils";

const DataFileSummary = ({ project }: { project: Project }) => {
  const inputData = getDataFileId(project as TextMiningProject);
  const { data: fileDetails } = useFetchDataFile(inputData);

  if (!projectIsTextMining(project)) {
    return null;
  }

  return (
    <div className="m-1">
      <p className="mb-2">
        <span className="font-semibold">Input Data:</span>{" "}
        <Link href={`/data-files/${inputData}`}>
          <a className="text-primary-main">{fileDetails?.name || inputData}</a>
        </Link>
      </p>
    </div>
  );
};

export default DataFileSummary;
